import { CmsCollectionWrapperDto } from "../cms-collection-wrapper/cms-collection-wrapper.dto";
import { CmsProductImageDto } from "../cms-product-image/cms-product-image.dto";
import { CmsResponseWrapperDto } from "../cms-response-wrapper/cms-response-wrapper.dto";

export class CmsProductImageApiResponseDto extends CmsResponseWrapperDto<CmsCollectionWrapperDto<CmsProductImageDto>> {}
